import { Injectable } from '@angular/core';
import { TranslationService } from './translation.service';

@Injectable()
export class ValidationService {
	private messageFormatters: Map<string, ValidationFormatter>;

	constructor(private _translationService: TranslationService) {
		this.messageFormatters = new Map<string, ValidationFormatter>();

		this.messageFormatters.set('required', (t: TranslationService, value?: any) => {
			return t.getString('Toto pole je povinné.');
		});

		this.messageFormatters.set('minlength', (t: TranslationService, value?: any) => {
			let txt = t.getString('Minimální počet znaků je {0}.');
			return txt.replace('{0}', value.requiredLength);
		});

		this.messageFormatters.set('maxlength', (t: TranslationService, value?: any) => {
			let txt = t.getString('Maximální počet znaků je {0}.');
			return txt.replace('{0}', value.requiredLength);
		});

		this.messageFormatters.set('pattern', (t: TranslationService, value?: any) => {
			return t.getString('Hodnota \'{actualValue}\' není validní: {requiredPattern}', value);
		});

		this.messageFormatters.set('validateEmail', (t: TranslationService, value?: any) => {
			return t.getString('E-mail není ve správném formátu.');
		});

		this.messageFormatters.set('validateBankCode', (t: TranslationService, value?: any) => {
			return t.getString('Číslo bankovního účtu není validní.');
		});

		this.messageFormatters.set('validateIBAN', (t: TranslationService, value?: any) => {
			return t.getString('Číslo IBAN není validní.');
		});

		this.messageFormatters.set('validateWordsLength', (t: TranslationService, value?: any) => {
			return t.getString('Maximální možná délka slova je 30 znaků.');
		});

		this.messageFormatters.set('number', (t: TranslationService, value?: any) => {
			if (value != true) {
				if (!isNaN(value.min) && !isNaN(value.max)) {
					return t.getString('Číslo musí být v rozsahu od {1} do {2}.', { 0: value.value, 1: value.min, 2: value.max });
				}

				if (!isNaN(value.min)) {
					return t.getString('Číslo musí být větší, než-li {1}.', { 0: value.value, 1: value.min });
				}

				if (!isNaN(value.max)) {
					return t.getString('Číslo musí být menší, než-li {1}.', { 0: value.value, 1: value.max });
				}
			}

			return t.getString('Zadejte prosím platné číslo.');
		});

		this.messageFormatters.set('remote', (t: TranslationService, value?: any) => {
			return value;
		});
	}

	getErrorMessageFor(validatorName: string, validatorValue?: any): string {
		if (this.messageFormatters.has(validatorName)) {
			return this.messageFormatters.get(validatorName)(this._translationService, validatorValue);
		}

		return null;
	}

	addFormatterFor(validatorName: string, formatter: ValidationFormatter) {
		this.messageFormatters.set(validatorName, formatter);
	}
}

export interface ValidationFormatter {
	(translationService: TranslationService, validatorValue?: any): string;
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/services/validation.service.ts